export default __webpack_public_path__ + "static/media/n.ef2b7949.png";